import React from "react";

import { RequestState } from "../../../utils/RequestState";

import styles from "./Verification.module.scss";

type Props = {
  verified: boolean;
  setVerified: (value: boolean) => void;
  setRequestState: (value: RequestState) => void;
};

const Verification: React.FC<Props> = ({
  verified,
  setVerified,
  setRequestState,
}) => {
  return (
    <div className={styles["c-verified"]}>
      <h2 className={styles["c-verified__title"]}>認証バッジ</h2>
      <div className={styles["c-verified__setting"]}>
        <input
          type="checkbox"
          id="verified"
          checked={verified}
          onChange={() => {
            setVerified(!verified);
            setRequestState(RequestState.Pending)
          }}
        />
        <label htmlFor="verified">{verified ? "解除する" : "付与する"}</label>
        <div className={styles["c-verified__help"]}>
          このまま保存するとバッジは
          <div>{verified ? "表示されます" : "表示されません"}</div>
        </div>
      </div>
    </div>
  );
};

export default Verification;
